import React, { useState, useEffect } from 'react';
import { Container, Label, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import '../../share/form.css';
import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';
import CreateTableComponent from "../../share/CreateTableComponent";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as Yup from 'yup'
import { BsPlusLg } from "react-icons/bs";
import { Loading } from '../../share/loading'
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit3 } from "react-icons/fi";
import TextErrors from "../../share/TextErrors";
import '../../share/TabStyle.css'
import "../../share/form.css";
import "../../share/DatePickerInputStyle.css"
import "../../share/ModalReactStrapStyle.css"
import '../../share/form.css';
import Swal from 'sweetalert2';

export function JobPositionFormTrainComponent() {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const user = JSON.parse(localStorage.getItem("userData"));
    // const [jobPosition, setJobPosition] = useState([]);

    const [cansubmit, setCanSubmit] = useState(false);
    // console.log("cansubmit", cansubmit)
    // console.log("confirmBorrow",confirmBorrow)
    const [courseSelect, setCourseSelect] = useState([]);
    // const [test, setTest] = useState([]);
    // console.log("test",test)
    // console.log("courseSelect", courseSelect)
    const [tabIndex, setTabIndex] = useState(0);
    const [detailJobPositionDataAr, setDetailJobPositionDataAr] = useState([]);
    // console.log("detailJobPositionDataAr", detailJobPositionDataAr)
    const [loading, setLoading] = useState(false);
    const [openModalForm, setOpenModalForm] = useState(false);
    const Toggle = () => setOpenModalForm(!openModalForm);

    useEffect(() => {
        ListTrainTestJobposition()
        getTrainJobposition()
        // ListTrainTestJobpositionAll()
    }, [])


    // ฟังก์ชั่นกรณีกดย้อนกลับ
    function checkPreviousPage() {
        return navigate(`/borrowing/BorrowForm/attatchFileTrain?req=${searchParams.get("req")}&train=${searchParams.get("train")}&test=${searchParams.get("test")}&status=${searchParams.get("status")}`)
    }



    useEffect(() => {
        async function checkCanSubmit() {
            let check = [];
            await courseSelect.forEach((course) => {
                course.listTrainClasses.forEach((classItem) => {
                    classItem.employeeAmount === classItem.personAmount ? check.push(true) : check.push(false)
                })
            })

            check.every(x => x === true) ? setCanSubmit(true) : setCanSubmit(false)

        }
        checkCanSubmit()
    }, [courseSelect])
    async function getTrainJobposition() {
        setLoading(true)
        let postData = new FormData();
        postData.append("borrowId", searchParams.get("req"))
        // postData.append("trainTest",1)
        try {

            let res = await fetch("/api/BorrowRegis/getTrainTestJobposition", {
                method: "POST",
                body: postData
            });
            const resJson = await res.json()
            // console.log("resJsongetTrainJobposition",resJson.dataenum)
            setDetailJobPositionDataAr(resJson.dataenum.filter(item => {
                return item.trainJobpositionName != null
            }));
        } catch (e) {
            // console.log(e)
        } finally {
            setLoading(false)
        }
    }

    async function ListTrainTestJobposition() {
        setLoading(true)
        try {
            let res = await fetch("/api/BorrowRegis/listTrainTestJobposition", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({
                    "BorrowId": searchParams.get("req")
                }),
            });
            const resJson = await res.json()
            // console.log('resJson',resJson.dataenum)
            setCourseSelect(resJson.dataenum.filter(item => {
                return item.trainCourseId != null
            }));
            // console.log(resJson.dataenum);
        } catch (err) {
            // console.log("err =>" + err)
        } finally {
            setLoading(false)
        }
    }

    const onSubmit = async (values) => {
        let postData = new FormData();
        postData.append("borrowId", values.borrowId)
        Swal.fire({
            icon: "info",
            title: "ยืนยันการส่งคำขอกู้ยืมเงินหรือไม่?",
            text: "",
            confirmButtonColor: rootColorPrimary,
            confirmButtonText: "ยันยัน",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await fetch("/api/BorrowRegis/confirmBorrow", {
                        method: "POST",
                        body: postData
                    });
                    let resJson = await res.json();

                    if (resJson.status === 1) {
                        setLoading(false)
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/borrowing/");
                            } else {
                                navigate("/borrowing/");
                            }
                        });
                    } else {
                        setLoading(false)
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    // console.log(e)
                }
            }
        })

    }

    const initialValues = {
        // detailJobPositionDataAr: detailJobPositionDataAr,
        borrowId: searchParams.get("req"),
    }
    const validationSchema = Yup.object().shape({

    })
    const detailJobpositionValidationSchema = Yup.object().shape({
        trainJobpositionName: Yup.string().required("กรุณากรอกชื่อตำแหน่งงาน"),

        personTotal: Yup.number()
            .typeError("กรุณากรอกตัวเลข")
            .positive("จำนวนพนักงานต้องมากกว่า 0")
            .required("กรุณากรอกจำนวนพนักงาน"),
        // .test(
        //     "sum-personAmount-not-exceed",
        //     "ผลรวมจำนวนผู้เข้ารับการฝึกอบรมต้องไม่เกินจำนวนพนักงาน",
        //     function (value) {
        //         const { trainCourses = [] } = this.parent || {};
        //         const totalSelected = trainCourses
        //             .flatMap((c) => c?.trainClasses || [])
        //             .reduce((sum, cls) => {
        //                 const selected = Number(cls?.trainClassId) > 0;
        //                 const amt = Number(cls?.personAmount || 0);
        //                 return sum + (selected ? amt : 0);
        //             }, 0);
        //         if (value === undefined || value === null || value === "") return true;
        //         return totalSelected <= Number(value || 0);
        //     }
        // ),

        trainCourses: Yup.array().of(
            Yup.object().shape({
                trainClasses: Yup.array().of(
                    Yup.object().shape({
                        trainClassId: Yup.number(),
                        employeeCapacity: Yup.number().nullable(), // ⭐ เพดานต่อรุ่น (read-only ใน schema)
                        personAmount: Yup.number()
                            .transform((val, orig) =>
                                orig === "" || orig === null ? undefined : val
                            )
                            .when("trainClassId", {
                                is: (v) => Number(v) > 0,
                                then: (schema) =>
                                    schema
                                        .typeError("กรุณากรอกตัวเลข")
                                        .positive("จำนวนคนต้องมีจำนวนมากกว่า 0")
                                        .required("กรุณากรอกจำนวนคน")
                                        .max(
                                            Yup.ref("employeeCapacity"),
                                            "จำนวนต้องไม่เกินจำนวนที่เปิดรับ"
                                        ),
                                otherwise: (schema) => schema.notRequired(),
                            }),
                    })
                ),
            })
        ),
    });



    const detailJobpositionInitialValues = {
        borrowId: searchParams.get("req"),
        registerId: user.registerId,
        id: 0,
        trainJobpositionName: "",
        personTotal: "",
        trainCourses: courseSelect.map((course) => ({
            trainCourseId: course.trainCourseId,
            trainClasses: course.listTrainClasses.map((classItem) => ({
                personAmount: "",
                trainClassId: 0,
                employeeCapacity: classItem.employeeAmount, // ⭐ เพดานของรุ่นนี้
            }))
        }))
    }

    const detailJobpositionOnSubmit = async (values) => {
        let pass = false;
        // console.log("values", values)

        const { trainCourses } = values
        await trainCourses.forEach((course) => {
            course.trainClasses.forEach((classItem) => {
                if (classItem.personAmount !== "") {
                    pass = true;
                    return;
                }
            })
        })

        if (pass) {
            Swal.fire({
                icon: "info",
                title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
                text: "",
                confirmButtonColor: rootColorPrimary,
                confirmButtonText: "ยันยัน",
                cancelButtonText: 'ยกเลิก',
                cancelButtonColor: '#d33',
                showCancelButton: true,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    // console.log(values)
                    try {
                        let res = await fetch("/api/BorrowRegis/saveTrainJobPosition", {
                            method: "POST",
                            headers: { "Content-type": "application/json" },
                            body: JSON.stringify(values)
                        });

                        let resJson = await res.json();

                        if (resJson.status === 1) {

                            Swal.fire({
                                icon: "success",
                                title: "บันทึกข้อมูลสำเร็จ",
                                text: "",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            }).then((result) => {
                                getTrainJobposition()
                                ListTrainTestJobposition()
                                Toggle()
                                if (result.isConfirmed) {
                                    return;
                                } else {
                                    navigate("/borrowing/");
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "บันทึกข้อมูลไม่สำเร็จ",
                                text: `เนื่องจาก ${resJson.message}`,
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            });
                        }
                    } catch (e) {
                        // console.log(e)
                    }
                    finally {
                        setLoading(false)
                    }
                }
            })
        } else {
            Swal.fire({
                icon: "warning",
                title: "",
                text: "กรุณาเลือกหลักสูตร / รุ่นการฝึกอบรมฯ อย่างน้อย 1 รายการ",
                confirmButtonColor: rootColorPrimary,
                confirmButtonText: "ตกลง",
            })
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ values, handleChange, setFieldValue, resetForm }) => {
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">

                                <Form className='p-5'>
                                    <Formik
                                        initialValues={detailJobpositionInitialValues}
                                        validationSchema={detailJobpositionValidationSchema}
                                        onSubmit={detailJobpositionOnSubmit}
                                        enableReinitialize

                                    >
                                        {({ values, handleChange, setFieldValue, resetForm, touched, errors }) => {
                                            // console.log("values", values)
                                            // console.log("errors", errors)

                                            async function OnEdit(row) {
                                                resetForm();
                                                // console.log("row", row)
                                                setFieldValue("id", row.id)
                                                setFieldValue("trainJobpositionName", row.trainJobpositionName)
                                                setFieldValue("personTotal", row.personTotal)

                                                await courseSelect.forEach((course, i) => {
                                                    row.trainCourses.forEach((mycourse) => {
                                                        if (course.trainCourseId === mycourse.trainCourseId) {
                                                            course.listTrainClasses.forEach((classItem, index) => {
                                                                mycourse.trainClasses.forEach((myClass) => {
                                                                    if (classItem.trainClassId === myClass.trainClassId) {
                                                                        setFieldValue(`trainCourses[${i}].trainClasses[${index}].trainClassId`, myClass.trainClassId);
                                                                        setFieldValue(`trainCourses[${i}].trainClasses[${index}].personAmount`, myClass.personAmount);
                                                                    }
                                                                })
                                                            })

                                                        }
                                                    })
                                                })
                                                await Toggle(!openModalForm);
                                            }

                                            async function OnDelete(id) {
                                                Swal.fire({
                                                    icon: "info",
                                                    title: "ยืนยันการลบข้อมูลหรือไม่?",
                                                    text: "",
                                                    confirmButtonColor: rootColorPrimary,
                                                    confirmButtonText: "ยันยัน",
                                                    cancelButtonText: 'ยกเลิก',
                                                    cancelButtonColor: '#d33',
                                                    showCancelButton: true,
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        let postData = new FormData();
                                                        postData.append("id", id)
                                                        try {
                                                            let res = await fetch("/api/BorrowRegis/deleteTrainJobposition", {
                                                                method: "POST",
                                                                body: postData
                                                            });
                                                            let resJson = await res.json();

                                                            if (resJson.status === 1) {
                                                                getTrainJobposition()
                                                                ListTrainTestJobposition()
                                                                Swal.fire({
                                                                    icon: "success",
                                                                    title: "ลบข้อมูลสำเร็จ",
                                                                    text: "",
                                                                    confirmButtonColor: "#0A66C2",
                                                                    confirmButtonText: "ตกลง",
                                                                }).then(() => {
                                                                    window.location.reload();

                                                                });
                                                            } else {
                                                                Swal.fire({
                                                                    icon: "error",
                                                                    title: "ลบข้อมูลไม่สำเร็จ",
                                                                    text: `เนื่องจาก ${resJson.message}`,
                                                                    confirmButtonColor: "#0A66C2",
                                                                    confirmButtonText: "ตกลง",
                                                                });
                                                            }

                                                        } catch (e) {
                                                            // console.log("err", e)
                                                        }
                                                    }
                                                })

                                            }

                                            const COLUMNS = [
                                                {
                                                    Header: "ลำดับ",
                                                    accessor: (_row, i) => i + 1,
                                                },
                                                {
                                                    Header: "ชื่อตำแหน่งงาน",
                                                    accessor: "trainJobpositionName",
                                                },
                                                {
                                                    Header: "จำนวนพนักงาน",
                                                    accessor: "personTotal",
                                                },
                                                {
                                                    Header: "จำนวนผู้เข้ารับการฝึกอบรม",
                                                    accessor: "personAmount",
                                                },
                                                {
                                                    Header: "รายละเอียด",
                                                    accessor: "id",
                                                    Cell: ({ row, value }) => {
                                                        return (
                                                            <div className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() =>
                                                                        OnEdit(row.original)
                                                                    }
                                                                >
                                                                    <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() =>
                                                                        OnDelete(row.original.id)
                                                                    }
                                                                >
                                                                    <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                </button>
                                                            </div>
                                                        );
                                                    },
                                                },
                                            ];
                                            async function onAdd() {
                                                resetForm();
                                                Toggle()
                                            }
                                            const AddDetailCourseBtn = () => {
                                                return (
                                                    <button
                                                        type='button'
                                                        className='btn-green'
                                                        onClick={() => onAdd()}
                                                    >
                                                        <BsPlusLg className="mx-2" />
                                                        เพิ่มข้อมูลตำแหน่งของพนักงาน
                                                    </button>
                                                );
                                            };


                                            return (
                                                <>
                                                    <div
                                                        className='d-flex justify-content-between align-items-center'
                                                    >
                                                        <Label>ข้อมูลตำแหน่งของพนักงานที่เข้ารับการฝึกอบรม</Label>
                                                    </div>
                                                    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                                        <TabList>
                                                            {courseSelect.map((course, i) => (
                                                                <Tab>หลักสูตร {course.courseName}</Tab>
                                                            ))}
                                                        </TabList>

                                                        {courseSelect?.map((course, index) => (
                                                            <TabPanel>
                                                                <div className='p-3' style={{ backgroundColor: "#E0F3FF" }}>
                                                                    {course.listTrainClasses.map((classItem) => (
                                                                        <li>
                                                                            รุ่นที่ {classItem.classItem} ผู้เข้ารับการฝึกอบรม {classItem.personAmount} / {classItem.employeeAmount}
                                                                        </li>
                                                                    ))}

                                                                </div>

                                                            </TabPanel>
                                                        ))}

                                                    </Tabs>


                                                    <div className='mt-2'>
                                                        <CreateTableComponent
                                                            column={COLUMNS}
                                                            dataInput={detailJobPositionDataAr}
                                                            FormInput={AddDetailCourseBtn}
                                                            showPage
                                                        />
                                                    </div>

                                                    <div>
                                                        <Modal
                                                            isOpen={openModalForm}
                                                            toggle={Toggle}
                                                            scrollable
                                                            backdrop={'static'}
                                                            keyboard={false}
                                                            centered
                                                            size="lg"
                                                        >
                                                            <ModalHeader toggle={Toggle} className="text-center styled-modal">
                                                                บันทึกข้อมูลตำแหน่งงาน
                                                            </ModalHeader>
                                                            <ModalBody>

                                                                <div className="w-100">
                                                                    <Form className="p-4" autoComplete="off">
                                                                        <Field
                                                                            name={`id`}
                                                                            type="text"
                                                                            disabled={true}
                                                                            style={{ display: "none" }}
                                                                        />
                                                                        <Label
                                                                            className="me-4 w-100 "
                                                                            style={{ lineHeight: "30px" }}
                                                                        >
                                                                            ชื่อตำแหน่งงาน
                                                                            <span className="require-input">*</span>
                                                                            {touched.trainJobpositionName && errors.trainJobpositionName ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.trainJobpositionName}
                                                                                </span>
                                                                            ) : null}

                                                                        </Label>
                                                                        <Field
                                                                            name={`trainJobpositionName`}
                                                                            type="text"
                                                                        >
                                                                            {({ field, meta, form }) => (
                                                                                <Input
                                                                                    type="text"
                                                                                    className={meta.touched && !form.values.trainJobpositionName ? "input-error rounded-pill text-center input-color cus-type" : " cus-type rounded-pill text-center input-color"}
                                                                                    {...field}
                                                                                />
                                                                            )}
                                                                        </Field>

                                                                        <Label
                                                                            className="me-4 w-100 "
                                                                            style={{ lineHeight: "30px" }}
                                                                        >
                                                                            จำนวนพนักงาน
                                                                            <span className="require-input">*</span>
                                                                            {/* {touched.personTotal && errors.personTotal ? (
                                                                                <span className="text-left text-danger px-1">
                                                                                    {errors.personTotal}
                                                                                </span>
                                                                            ) : null} */}

                                                                        </Label>
                                                                        <Field
                                                                            name={`personTotal`}
                                                                            type="number"
                                                                        >
                                                                            {({ field, meta, form }) => (
                                                                                <Input
                                                                                    type="number"
                                                                                    className={meta.touched && !form.values.personTotal ? "input-error rounded-pill text-center input-color cus-type" : " cus-type rounded-pill text-center input-color"}
                                                                                    {...field}
                                                                                />
                                                                            )}
                                                                        </Field>

                                                                        <Label
                                                                            className='mt-3'>
                                                                            กรุณาเลือกหลักสูตรและรุ่นการฝึกอบรม
                                                                            <span className="require-input">*</span>
                                                                        </Label>
                                                                        <FieldArray name={`trainCourses`}>
                                                                            {(fieldArrayProps) => {
                                                                                return (
                                                                                    <>
                                                                                        {courseSelect?.map((course, i) => (
                                                                                            <div className='mt-3 px-3' key={i}>
                                                                                                <li>หลักสูตร <span style={{ color: "#0A66C2" }}>{course.courseName}</span></li>
                                                                                                {course.listTrainClasses.map((classItem, index) => (
                                                                                                    <div key={index} >
                                                                                                        <div className='d-flex align-items-center mt-3'>
                                                                                                            <Field
                                                                                                                name={`trainCourses[${i}].trainClasses[${index}].trainClassId`}
                                                                                                                type="checkbox"
                                                                                                            >
                                                                                                                {({ field, meta, form }) => (
                                                                                                                    <Input
                                                                                                                        type="checkbox"
                                                                                                                        className="ms-2 cus-type m-0"
                                                                                                                        {...field}
                                                                                                                        onChange={(e) => {
                                                                                                                            handleChange(e)
                                                                                                                            if (e.target.checked) {
                                                                                                                                setFieldValue(`trainCourses[${i}].trainClasses[${index}].trainClassId`, classItem.trainClassId);
                                                                                                                            } else {
                                                                                                                                setFieldValue(`trainCourses[${i}].trainClasses[${index}].trainClassId`, 0);
                                                                                                                                setFieldValue(`trainCourses[${i}].trainClasses[${index}].personAmount`, "");
                                                                                                                            }

                                                                                                                        }}
                                                                                                                        checked={values.trainCourses[i].trainClasses[index].trainClassId !== 0 ? true : false}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </Field>
                                                                                                            <span className='ms-2'>
                                                                                                                รุ่นที่ <span style={{ color: "#0A66C2" }}>{classItem.classItem}</span>
                                                                                                            </span>

                                                                                                            <span className='ms-2'>
                                                                                                                จำนวนผู้เข้ารับการฝึกอบรม
                                                                                                            </span>

                                                                                                            <Field
                                                                                                                name={`trainCourses[${i}].trainClasses[${index}].personAmount`}
                                                                                                                type="text"
                                                                                                            >
                                                                                                                {({ field, meta, form }) => (
                                                                                                                    <Input
                                                                                                                        type="text"
                                                                                                                        className="cus-type rounded-pill input-color w-25 ms-3 text-center"
                                                                                                                        disabled={values.trainCourses[i].trainClasses[index].trainClassId === 0 ? true : false}
                                                                                                                        {...field}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </Field>
                                                                                                            <span className='ms-2'>
                                                                                                                คน
                                                                                                            </span>
                                                                                                            <div>
                                                                                                                {touched.personTotal && errors.personTotal ? (
                                                                                                                    <span className="text-left text-danger px-1">
                                                                                                                        {errors.personTotal}
                                                                                                                    </span>
                                                                                                                ) : null}
                                                                                                                {/* <ErrorMessage name={`trainCourses[${i}].trainClasses[${index}].personAmount`} component={TextErrors} /> */}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                )
                                                                            }}
                                                                        </FieldArray>
                                                                        <hr />
                                                                        <div className='d-flex justify-content-center align-items-center'>
                                                                            <button className='btn-blue w-25' type="submit">บันทึก</button>
                                                                        </div>
                                                                    </Form>


                                                                </div>
                                                            </ModalBody>


                                                        </Modal>

                                                    </div>


                                                </>
                                            )
                                        }}


                                    </Formik>

                                    <div className='d-flex justify-content-between align-items-center mt-5'>

                                        <button
                                            onClick={checkPreviousPage}
                                            type="button"
                                            className='btn-blue px-4 w-25'
                                        >
                                            ย้อนกลับ
                                        </button>
                                        {searchParams.get("test") === "true" ? (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        navigate(`/borrowing/BorrowForm/testDetail?req=${searchParams.get("req")}&train=${searchParams.get("train")}&test=${searchParams.get("test")}&status=${searchParams.get("status")}`)}
                                                    className='btn-blue px-4 w-25'
                                                    disabled={!cansubmit}
                                                >
                                                    ถัดไป
                                                </button>

                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    type="submit"
                                                    className='btn-blue px-4 w-25'
                                                    disabled={!cansubmit}
                                                >
                                                    ส่งคำขอ
                                                </button>
                                            </>

                                        )}



                                    </div>

                                </Form>


                            </div>

                        ) : (
                            <Loading />
                        )

                        }

                    </Container>


                )

            }}
        </Formik>
    );
}

